import { gql } from '@apollo/client';

export const CreateVendorClaimMutation = gql`
  mutation createVendorClaimCustom($vendorRewardId: ID!) {
    createVendorClaimCustom(vendorRewardId: $vendorRewardId) {
      id
    }
  }
`;
